import * as yup from "yup";

export const titleContentFormSchema = yup
  .object()
  .shape({
    title: yup.string().required("Title is required."),
    content: yup.string().required("Content is required."),
  })
  .required();

export const imageFormSchema = yup
  .object()
  .shape({
    image: yup.mixed().required("Please upload an image."),
  })
  .required();

export const baseStringDto = (label, min = 0, max) => {
  let schema = yup.string().required(`${label} is required.`);
  if (min) {
    schema = schema.min(min, `${label} must be at least ${min} characters.`);
  }
  if (max) {
    schema = schema.max(max, `${label} must be at most ${max} characters.`);
  }
  return schema;
};
